import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ctrlplaneApi, PortalSettings } from '../../utils/api/ctrlplane';

// Workspace card → Client portal address (server: firmSettings.portalBaseUrl). Its own small form with
// its own Save, so the Workspace card's save payload is untouched.
const input: React.CSSProperties = {
  width: '100%', padding: '9px 12px', fontSize: 13, borderRadius: 'var(--radius-md)',
  border: '1px solid var(--border-strong)', background: 'var(--c-gray-50)', color: 'var(--text-primary)', outline: 'none',
};
const lbl: React.CSSProperties = { fontSize: 11, fontWeight: 600, color: 'var(--text-secondary)', display: 'block', marginBottom: 4 };
const note: React.CSSProperties = { fontSize: 11, color: 'var(--text-tertiary)', marginTop: 4 };

export default function WorkspacePortalAddress() {
  const { t } = useTranslation();
  const [s, setS] = useState<PortalSettings | null>(null);
  const [v, setV] = useState('');
  const [err, setErr] = useState(''); const [msg, setMsg] = useState(''); const [saving, setSaving] = useState(false);
  const take = (d: PortalSettings) => { setS(d); setV(d.portalBaseUrl || ''); };
  useEffect(() => { ctrlplaneApi.portalSettings().then(take).catch((e: any) => setErr(e.message)); }, []);
  const save = async () => {
    setSaving(true); setErr(''); setMsg('');
    try { take(await ctrlplaneApi.savePortalBaseUrl(v)); setMsg(t('cs_saved')); setTimeout(() => setMsg(''), 2000); }
    catch (e: any) { setErr(e.message); } finally { setSaving(false); }
  };
  const env = !!s?.portalBaseFromEnv;
  const status = !s ? '' : env ? t('ctrl_portal_base_env')
    : !s.portalBaseEffective ? t('ctrl_portal_base_unset')
    : s.portalBaseDefault ? t('ctrl_portal_base_default', { url: s.portalBaseEffective })
    : t('ctrl_portal_base_in_use', { url: s.portalBaseEffective });
  return (
    <div style={{ marginTop: 12 }}>
      <label style={lbl}>{t('ctrl_portal_base')}</label>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <input value={env ? (s?.portalBaseEffective || '') : v} disabled={env || !s} onChange={e => setV(e.target.value)}
          style={{ ...input, opacity: env ? 0.7 : 1 }} placeholder={s?.portalBaseDefault ? s.portalBaseEffective : 'https://…/portal'} />
        {!env && (
          <button onClick={save} disabled={saving || !s} style={{ padding: '8px 14px', borderRadius: 'var(--radius-md)', border: 'none', background: 'var(--accent)', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}>
            {saving ? t('login_wait') : t('save')}
          </button>
        )}
        {msg && <span style={{ fontSize: 12, color: '#1D9E75', whiteSpace: 'nowrap' }}><i className="ti ti-check" style={{ marginRight: 4 }} />{msg}</span>}
      </div>
      <div style={note}>{t('ctrl_portal_base_hint')}</div>
      {status && <div style={{ ...note, color: s && !s.portalBaseEffective ? '#B45309' : note.color }}>{status}</div>}
      {s?.corsGap && <div style={{ ...note, color: '#B45309' }}>{t('ctrl_portal_cors_gap', { origin: s.corsGap })}</div>}
      {err && <div style={{ fontSize: 12, color: '#E24B4A', background: '#FCEBEB', padding: '6px 10px', borderRadius: 'var(--radius-md)', marginTop: 6 }}>{err}</div>}
    </div>
  );
}
